export default "__VITE_ASSET__k4o3M3sY__"